// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import Icon_smile from '../../img/hola2023/icons/16/smile.svg';
import Icon_crown from '../../img/hola2023/icons/16/crown.svg';
import Icon_parameters from '../../img/hola2023/icons/16/parameters.svg';
import Icon_devices from '../../img/hola2023/icons/16/devices.svg';
import Icon_chat_dots from '../../img/hola2023/icons/16/chat_dots.svg';
import Icon_chevron_right from '../../img/hola2023/icons/16/chevron_right.svg';
import {t_use_cp} from './use_cp';
import styles from './cp_menu.module.less';

interface i_tab {
    tab: t_use_cp['tab'];
    title: string;
    icon: JSX.Element;
}
const tabs: i_tab[] = [
    {tab: 'profile', title: 'My profile', icon: <Icon_smile/>},
    {tab: 'premium', title: 'My Plan', icon: <Icon_crown/>},
    {tab: 'settings', title: 'Settings', icon: <Icon_parameters/>},
    {tab: 'apps', title: 'Products & devices', icon: <Icon_devices/>},
    {tab: 'support', title: 'Support', icon: <Icon_chat_dots/>},
];

interface i_menu_props {
    class_name?: string;
    active: t_use_cp['tab'];
    root_path: string;
}
export const CP_menu = (props: i_menu_props)=>{
    const {active, root_path, class_name} = props;
    const ic_right = <Icon_chevron_right width={16} height={16}
      className={styles.arrow_right}/>;
    return <div className={cn(class_name, styles.menu)}>
      {tabs.map(({tab, title, icon})=>{
          const cls = cn(styles.link, {[styles.active]: active == tab});
          return <Link key={tab} className={cls} to={`${root_path}/${tab}`}>
            <span>{icon}{title}{ic_right}</span>
          </Link>;
      })}
    </div>;
};
